import { render, staticRenderFns } from "./selectSize.vue?vue&type=template&id=188c75e8&scoped=true&"
import script from "./selectSize.vue?vue&type=script&lang=js&"
export * from "./selectSize.vue?vue&type=script&lang=js&"
import style0 from "./selectSize.vue?vue&type=style&index=0&id=188c75e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c75e8",
  null
  
)

export default component.exports